import { dramas } from "@/mocks/dramas";
import { actors } from "@/mocks/actors";
import type { Actor, Drama } from "@/types/content";

export const allDramas = dramas as Drama[];
export const allActors = actors as Actor[];

export const DRAMA_TYPES = ["电影", "电视剧", "网剧"];
export const REGIONS = ["中国大陆", "中国香港", "美国", "韩国", "日本"];
export const YEARS = [2024, 2023, 2022];

export function getDramaById(id?: string): Drama | undefined {
  if (!id) return undefined;
  return allDramas.find((drama) => drama.id === id);
}

export function getActorById(id?: string): Actor | undefined {
  if (!id) return undefined;
  return allActors.find((actor) => actor.id === id);
}

export function getDramaTitle(id: string): string {
  return getDramaById(id)?.title ?? "";
}

export function getRelatedDramas(drama: Drama, limit = 3): Drama[] {
  return allDramas
    .filter((item) => item.id !== drama.id)
    .map((item) => {
      const genreMatch = item.genres.filter((genre) => drama.genres.includes(genre)).length;
      const tagMatch = item.tags.filter((tag) => drama.tags.includes(tag)).length;
      const typeMatch = item.type === drama.type ? 1 : 0;
      return { item, score: genreMatch * 3 + tagMatch * 2 + typeMatch };
    })
    .sort((a, b) => b.score - a.score || b.item.popularity - a.item.popularity)
    .slice(0, limit)
    .map((entry) => entry.item);
}

export function searchDramas(keyword: string): Drama[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return allDramas.filter(
    (drama) =>
      drama.title.toLowerCase().includes(q) ||
      drama.genres.some((genre) => genre.toLowerCase().includes(q)) ||
      drama.director.toLowerCase().includes(q) ||
      drama.cast.some((member) => member.name.toLowerCase().includes(q)) ||
      drama.tags.some((tag) => tag.toLowerCase().includes(q)),
  );
}

export function searchActors(keyword: string): Actor[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return allActors.filter(
    (actor) =>
      actor.name.toLowerCase().includes(q) ||
      actor.tags.some((tag) => tag.toLowerCase().includes(q)) ||
      actor.works.some((work) => work.title.toLowerCase().includes(q)),
  );
}

export function filterDramas(options: {
  type?: string;
  region?: string;
  year?: string;
  sort?: string;
}): Drama[] {
  const { type, region, year, sort } = options;
  let result = allDramas.filter((drama) => {
    if (type && drama.type !== type) return false;
    if (region && drama.region !== region) return false;
    if (year && String(drama.year) !== year) return false;
    return true;
  });
  if (sort === "hot") {
    result = [...result].sort((a, b) => b.popularity - a.popularity);
  } else if (sort === "rating") {
    result = [...result].sort((a, b) => b.rating - a.rating);
  } else {
    result = [...result].sort((a, b) => b.releaseDate.localeCompare(a.releaseDate));
  }
  return result;
}

export function formatDate(date: string): string {
  const [y, m, d] = date.split("-");
  return `${y}年${Number(m)}月${Number(d)}日`;
}